import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "720",
  fill: "none",
  viewBox: "0 0 720 747"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#00699D",
      d: "M0 0h720v747H0z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "784",
      cy: "761",
      r: "262.5",
      stroke: "#fff",
      "stroke-opacity": ".3"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "581",
      cy: "873",
      r: "262.5",
      stroke: "#fff",
      "stroke-opacity": ".3"
    }, null, -1)
  ]))]))
}
export default { render: render }